import React from 'react';

export const SqCheckmark: React.FC = () => (
  <div
    className="tw-w-6 tw-h-6 tw-flex-shrink-0 tw-rounded-full tw-flex tw-items-center tw-justify-center"
    style={{ backgroundColor: 'var(--bg-color-primary-button)' }}
  >
    <svg className="tw-w-3.5 tw-h-3.5" viewBox="0 0 20 20" fill="none">
      <path
        d="M4 10l4.5 4.5L16 6"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
);
